import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { cards } from 'sections/DigitalTools/ShipSchedules/data';
import { Card as CardType } from 'sections/DigitalTools/ShipSchedules/types';
import styles from 'sections/DigitalTools/ShipSchedules/components/SectionCoverage/SectionCoverage.module.scss';

const cn = classNames.bind(styles);

const SectionCoverage = (): ReactElement => {
  const cardsElements = cards.map((card: CardType) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-box')}>
            <h4 className={cn('card__heading')}>
              <span>{card.title.firstLine}</span>{' '}
              <span>{card.title.secondLine}</span>
            </h4>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('coverage')}>
      <div className={cn('container')}>

        <div className={cn('coverage__heading-box')}>
          <h2 className={cn('coverage__heading')}>
            Global Coverage
          </h2>
          <p className={cn('coverage__heading-description')}>
            SeaRates’ smart solution puts the global shipping network at your fingertips,
            delivering dynamic tools for planning, port insights, and precise shipment
            vessel tracking, designed to streamline container ship schedules, strengthen
            supply chain strategies, and support smarter shipping, with:
          </p>
        </div>

        <div className={cn('coverage__cards')}>
          {cardsElements}
        </div>

      </div>
    </section>
  );
};

export default SectionCoverage;